import React, { useMemo, useEffect, useState, useRef } from 'react';
import classNames from 'classnames';

interface Props {
	start_time?: number;
	end_time?: number;
	show_session_type: string;
	includeCountdown?: boolean;
}

function isToday(d: Date) {
	const today = new Date();
	return d.getDate() === today.getDate() && d.getMonth() === today.getMonth() && d.getFullYear() === today.getFullYear();
}

function getCountdownTime(ended: boolean, startDate: Date, started: boolean, hours: number) {
	if (ended) return 60 * 60 * 1000;
	if (!isToday(startDate)) return 60 * 60 * 1000;
	if (!started) {
		if (hours >= 2)
			return 60 * 1000;
		else
			return 1000;
	}
	return 1000;
}

export default function Badges(props: Props) {
	const {
		start_time = 0,
		end_time = 0,
		show_session_type,
		includeCountdown = true
	} = props;

	const startDate = new Date(start_time);
	const endDate = new Date(end_time);
	const startTime = startDate.valueOf();
	const endTime = endDate.valueOf();
	const started = startTime - Date.now() < 0;
	const ended = endTime - Date.now() < 0;
	const during = started && !ended;
	const time = Math.abs(startTime - Date.now());
	const _seconds = Math.floor((time / 1000) % 60);
	const _mins = Math.floor((time / 1000 / 60) % 60);
	const _hours = Math.floor((time / (1000 * 60 * 60)) % 24);

	const [elapsed, setElapsed] = useState(0);
	const timeout = useRef(undefined as undefined | NodeJS.Timeout);

	const getTime = useMemo(() => {
		if (during) {
			if (_hours < 1) {
				return `${String(_mins).padStart(2, "0")}:${String(_seconds).padStart(2, "0")}`;
			} else {
				return `${String(_hours).padStart(2, "0")}:${String(_mins).padStart(2, "0")}:${String(_seconds).padStart(2, "0")}`;
			}
		}

		if (!started && _hours > 0) {
			if (_hours === 1 && _mins === 59) {
				return 'Starts in 2h 0m';
			} else {
				return `Starts in ${String(_hours)}h ${String(_mins + 1)}m`;
			}
		} else {
			if (_hours === 0 && _mins === 59) {
				return 'Starts in 1 hour';
			} else {
				return `Starts in ${String(_mins + 1)} min`;
			}
		}
	}, [elapsed, start_time]);

	useEffect(() => {
		timeout.current = setTimeout(() => {
			setElapsed(elapsed + 1000);
		}, getCountdownTime(ended, startDate, started, _hours));

		return () => {
			if (timeout.current) {
				clearTimeout(timeout.current)
			}
		}
	});

	return (
		<>
			<div className="badges-wrapper">
				<div className={classNames('event-type', show_session_type && show_session_type.toLowerCase(), 'corner-round-large', includeCountdown && 'margin-right-small')}>
					<span className='text-transform-capitalize'>{show_session_type}</span>
				</div>
				{isToday(startDate) && includeCountdown && (
					<>
						{!started && _hours < 2 && (
							<div className="countdown-badge">
								<span>{getTime}</span>
							</div>
						)}
						{during && (
							<div className="live-badge">
								<div className="live-indicator" />
								<span style={{ fontWeight: 500 }}>LIVE&nbsp;</span>
								<span>{getTime}</span>
							</div>
						)}
					</>
				)}
			</div>
		</>
	)
}